// Импорт стилей
import '../scss/main.scss';

// Импорт библиотек из npm
// import $ from 'jquery';
import gsap from "gsap";

const tabBtns = document.querySelectorAll('.tabs-nav__btn');
const tabTags = document.querySelectorAll('.tabs-tags__container');
const tabImages = document.querySelectorAll('.tabs-nav__image-wrapper');
const selectScreenOne = document.querySelector('.screen-1__select');


// Функция инициализации кастомного курсора
function initCustomCursor() {
    // Получаем контейнер кнопок и элемент кастомного курсора
    const buttonsContainer = document.querySelector('.tabs-nav__images');
    const customCursor = document.getElementById('customCursor');

    if (!buttonsContainer || !customCursor) {
        // Если элементы не найдены, прекращаем выполнение
        return;
    }

    // Обработчик движения мыши
    document.addEventListener('mousemove', (e) => {
        customCursor.style.left = `${e.pageX}px`;
        customCursor.style.top = `${e.pageY}px`;
    });

    // Обработчик наведения на элементы a.tabs-nav__image-wrapper
    buttonsContainer.addEventListener('mouseover', (e) => {
        // Проверяем, что наведение произошло на элемент a с нужным классом
        if (e.target.tagName === 'A' && e.target.classList.contains('tabs-nav__image-wrapper')) {
            customCursor.style.opacity = 1;
        }
    });

    // Обработчик ухода курсора с элементов a.tabs-nav__image-wrapper
    buttonsContainer.addEventListener('mouseout', (e) => {
        // Проверяем, что уход курсора произошел с элемента a с нужным классом
        if (e.target.tagName === 'A' && e.target.classList.contains('tabs-nav__image-wrapper')) {
            customCursor.style.opacity = 0;
        }
    });
}



// Проверяем, есть ли у устройства поддержка точного указателя и hover
const hasFinePointer = window.matchMedia('(pointer: fine) and (hover: hover)').matches;

if (hasFinePointer) {
    // Инициализируем кастомный курсор только для устройств с точным указателем
    initCustomCursor();
}


// Табы
tabBtns.forEach((btn, index) => {
    btn.addEventListener('click', function (e) {
        tabBtns.forEach(btn => {
            btn.classList.remove('active');
        })
        btn.classList.add('active');

        const number = index;
        const tag = tabTags[index];
        const image = tabImages[index + 1];

        tabTags.forEach((tag, index) => {
            tag.style.display = 'none';
        });
        tabImages.forEach((image, index) => {
            image.style.display = 'none';
        });

        tag.style.display = 'flex';
        image.style.display = 'flex';


        gsap.fromTo(
            tag,
            {
                opacity: 0,
            },
            {
                duration: 0.5,
                opacity: 1,
            }
        )
        gsap.fromTo(
            image,
            {
                opacity: 0,
            },
            {
                duration: 0.5,
                opacity: 1,
            }
        )
        // Анимируем selectScreenOne (затухание)
        gsap.to(selectScreenOne, {
            duration: 0.5,
            opacity: 0,
            onComplete: () => {
                // selectScreenOne.style.display = 'none';
            }
        });

        if (window.outerWidth >= 1200) {
            // Анимируем заголовок (изменение margin-top)
            gsap.to('.screen-1__title', {
                duration: 0.5,
                marginTop: '20px',
                ease: 'power1.out' // Добавляем плавную функцию перехода для большей мягкости
            });
        } else if (window.outerWidth >= 768 && window.outerWidth <= 1199) {
            document.querySelector('.screen-1__title').classList.add('anim');
        }

    });
});

// в мобилке перемещаем блок с табами под картинку

document.addEventListener('DOMContentLoaded', function () {
    const elementToMove = document.getElementById('tabs-tags');
    const mobileTarget = document.getElementById('tabs-nav');
    const desktopTarget = document.querySelector('.screen-1__descr');
    const textElement = document.querySelector('.pervaya_pechatnaya_reklama');

    const navLinks = document.querySelectorAll('.nav__link');


    // Функция для выполнения действий при изменении размера экрана
    function handleResizeActions() {
        const windowWidth = window.innerWidth;

        // Перемещение элемента в зависимости от ширины экрана
        if (windowWidth < 767) {
            // Перемещение после tabs-nav на мобильных устройствах
            if (elementToMove.parentNode !== mobileTarget.parentNode || mobileTarget.nextElementSibling !== elementToMove) {
                mobileTarget.insertAdjacentElement('afterend', elementToMove);
            }

            // Изменение текста для мобильных устройств
            textElement.textContent = 'печатная реклама';

            navLinks.forEach(element => {
                element.addEventListener('click', function (e) {
                    navLinks.forEach(elem => {
                        elem.classList.remove('active');
                    })
                    this.classList.toggle('active');
                })
            });
            document.querySelectorAll('filter feGaussianBlur').forEach(elem => {
                elem.setAttribute('stdDeviation', '6');
            })

        } else {
            // Перемещение после .screen-1__descr на больших экранах
            if (elementToMove.parentNode !== desktopTarget.parentNode || desktopTarget.nextElementSibling !== elementToMove) {
                desktopTarget.insertAdjacentElement('afterend', elementToMove);
            }

            // Изменение текста для больших экранов
            textElement.textContent = 'первая печатная реклама';

            document.querySelectorAll('filter feGaussianBlur').forEach(elem => {
                elem.setAttribute('stdDeviation', '21');
            })
        }

        // Проверяем, если хотя бы у одного элемента есть класс 'active'
        const hasActive = Array.from(document.querySelectorAll('.tabs-nav__btn')).some(element => element.classList.contains('active'));

        // Меняем положение заголовка, чтобы не поехала верстка
        if (window.outerWidth >= 768 && window.outerWidth <= 1199 && hasActive) {
            document.querySelector('.screen-1__title').classList.add('anim');
        }
        if (windowWidth >= 768 && windowWidth < 1200) {
            document.querySelectorAll('filter feGaussianBlur').forEach(elem => {
                elem.setAttribute('stdDeviation', '15.5');
            })
            // document.querySelectorAll('filter feColorMatrix').forEach(elem=>{
            //     elem.setAttribute('values', '1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 20 -10');
            // })
        }
    }

    // Первоначальный вызов функции при загрузке страницы
    handleResizeActions();

    // Добавляем обработчик события resize с использованием debounce для оптимизации
    let resizeTimeout;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(handleResizeActions, 150);
    });
});

// Функция для плавного скролла
function smoothScroll(target) {
    const element = document.querySelector(target);
    if (element) {
        let headerHeight = document.querySelector('header').offsetHeight;
        let offset = headerHeight + 40;

        const targetPosition = element.getBoundingClientRect().top + window.pageYOffset - offset;
        console.log(element);

        window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
        });
    }
}
// Выбираем все ссылки <a> с href="#"
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();
        smoothScroll(this.getAttribute('href'));
    });
});




// Массив конфигураций для каждого экземпляра слайдера Swiper
var swiperConfigs = [
    {
        container: ".screen-3__slider",
        direction: 'default',
        initialSlide: 2,
        spaceBetween: 10,
        nextEl: ".swiper-button-next1",
        prevEl: ".swiper-button-prev1",
    },
    {
        container: ".screen-4__slider",
        direction: 'top',
        initialSlide: 2,
        spaceBetween: 10,
        nextEl: ".swiper-button-next2",
        prevEl: ".swiper-button-prev2",
    },
    {
        container: ".screen-6__slider",
        direction: 'default',
        initialSlide: 1,
        spaceBetween: 10,
        nextEl: ".swiper-button-next3",
        prevEl: ".swiper-button-prev3",
    },
    {
        container: ".screen-7__slider",
        direction: 'top',
        initialSlide: 1,
        spaceBetween: 10,
        nextEl: ".swiper-button-next4",
        prevEl: ".swiper-button-prev4",
    },
];

// Функция для инициализации экземпляра слайдера Swiper с заданными опциями
function initializeSwiper(options) {
    var swiper = new Swiper(options.container + " .swiper", {
        centeredSlides: true, // Центральный слайд всегда находится в центре
        slidesPerView: 'auto', // Автоматическая ширина слайда в зависимости от содержимого
        loop: true, // Бесконечный режим прокрутки
        spaceBetween: 10, // Расстояние между слайдами
        speed: 500, // Скорость перехода в миллисекундах
        allowTouchMove: false, // Отключить сенсорные взаимодействия
        slideToClickedSlide: true,  // Клик по слайду переключает слайды
        initialSlide: options.initialSlide,
        pagination: {
            el: ".swiper-pagination", // Элемент пагинации (точки внизу)
        },
        navigation: {
            nextEl: options.nextEl, // Кнопка "Вперед"
            prevEl: options.prevEl, // Кнопка "Назад"
        },
        on: {
            // Событие при инициализации слайдера
            init: function () {
                if (window.innerWidth >= 1199) { // Применяется только для планшетов и десктопов
                    this.sliderDirection = options.direction; // Установка направления ('top' или 'default')
                    setTimeout(() => {
                        updateSlide(this); // Позиционирование всех слайдов
                    }, 1000);

                } else if (window.innerWidth >= 768) {
                    this.sliderDirection = options.direction; // Установка направления ('top' или 'default')
                    setTimeout(() => {
                        updateSlide(this); // Позиционирование всех слайдов
                    }, 1000);
                } else {
                    setTimeout(() => {
                        updateSlide(this); // Позиционирование всех слайдов
                    }, 1000);
                }
            },
            // Событие при начале перехода слайда
            slideChangeTransitionStart: function () {
                updateSlide(this); // Обновление позиций слайдов
            },
            // Событие при окончании перехода слайда
            slideChangeTransitionEnd: function () {
                // Пересоздание слайдов для корректной работы бесконечной прокрутки
                this.loopDestroy();
                this.loopCreate();
                this.update();
            },
            // Событие при изменении размера окна
            resize: function () {
                if (window.innerWidth >= 768) {
                    // Для планшетов и десктопов
                    this.allowTouchMove = false;
                    this.params.centeredSlides = true;
                    this.update();
                    updateSlide(this);
                } else {
                    // Для мобильных устройств
                    this.allowTouchMove = true;
                    this.update();
                    updateSlide(this);
                }
            }
        },
        breakpoints: {
            // Настройки для экранов от 320px до 767px
            320: {
                slidesPerView: 'auto',
                spaceBetween: options.spaceBetween,
                allowTouchMove: true,
                // Нет необходимости в пользовательском позиционировании слайдов
            },
            // Для экранов от 768px и выше применяются стандартные настройки
        }
    });
    return swiper;
}

// Инициализация всех экземпляров слайдеров с использованием конфигураций
swiperConfigs.forEach(function (config) {
    initializeSwiper(config);
});

// Функция для обновления позиции и внешнего вида каждого слайда
// Функция для обновления позиции и внешнего вида каждого слайда
function updateSlide(swiper) {
    const slides = swiper.slides; // Все слайды в слайдере
    const activeIndex = swiper.activeIndex; // Индекс текущего активного слайда
    const previousIndex = swiper.previousIndex; // Индекс предыдущего слайда
    const totalSlides = slides.length; // Общее количество слайдов

    // Получение конфигурации в зависимости от направления и размера экрана
    const config = getDirectionConfig(swiper.sliderDirection);

    // Определяем направление движения: 'next' или 'prev'
    const direction = (activeIndex > previousIndex || (activeIndex === 0 && previousIndex === totalSlides - 1)) ? 'next' : 'prev';

    slides.forEach((slide, index) => {
        // Сброс стилей перед применением новых трансформаций
        slide.style.transition = 'transform 0.5s ease'; // Плавная анимация переходов
        slide.style.transform = ''; // Сброс трансформации
        slide.style.opacity = '1'; // Полная видимость
        slide.style.transformOrigin = ''; // Сброс точки вращения
        slide.style.display = ''; // Стандартный режим отображения

        // Рассчитываем расстояние слайда от активного слайда
        let distance = index - activeIndex;

        // Корректировка расстояния для бесконечных слайдов
        if (distance < -totalSlides / 2) {
            distance += totalSlides;
        } else if (distance > totalSlides / 2) {
            distance -= totalSlides;
        }

        // Анимация для text-block на всех разрешениях
        let textBlock = slide.querySelector(".text-block");
        if (textBlock) {
            if (distance === 0) {
                // Анимация появления текста для центрального слайда
                gsap.to(textBlock, {
                    duration: 0.5,
                    opacity: 1,
                    ease: "power2.out"
                });
            } else {
                // Скрытие текста для всех нецентральных слайдов
                gsap.to(textBlock, {
                    duration: 0.5,
                    opacity: 0,
                    ease: "power2.out"
                });
            }
        }

        // Логика позиционирования слайдов только для планшетов и десктопов
        if (config) {
            // Если это центральный слайд
            if (distance === 0) {
                slide.style.transform = 'translateX(0px) translateY(0px) translateZ(0px) rotate(0deg)'; // Центральный слайд без изменений
                // Установка точки вращения в зависимости от направления движения
                slide.style.transformOrigin = direction === 'next' ? config.centerOriginNext : config.centerOriginPrev;
            } else {
                // Для остальных слайдов рассчитываем позицию и угол поворота
                let translateX, translateY, translateZ;
                let angleMultiplier = distance; // Множитель для угла поворота в зависимости от расстояния
                let rotateValue = config.rotationAngle * angleMultiplier; // Угол поворота для слайда

                if (Math.abs(distance) === 1) {
                    // Слайды, соседствующие с центральным
                    translateX = config.radiusXClose * angleMultiplier; // Смещение по оси X
                    translateY = config.radiusYClose; // Смещение по оси Y
                    translateZ = -config.depthZClose; // Глубина по оси Z
                } else {
                    // Слайды, удаленные от центрального
                    translateX = config.radiusXFar * angleMultiplier; // Большее смещение по оси X
                    translateY = config.radiusYFar; // Смещение по оси Y для эффекта глубины
                    translateZ = -config.depthZFar * Math.abs(distance); // Глубина по оси Z
                }

                // Определение точки вращения
                let originX = distance > 0 ? config.originXNext : config.originXPrev; // Левый или правый угол в зависимости от направления
                let originY = config.originY; // Точка вращения по оси Y

                // Применение трансформации к слайду
                slide.style.transform = `translateX(${translateX}px) translateY(${translateY}px) translateZ(${translateZ}px) rotate(${rotateValue}deg)`;
                slide.style.transformOrigin = `${originX} ${originY}`;

                // Уменьшение видимости для дальних слайдов для создания эффекта глубины
                slide.style.opacity = 1 - Math.abs(distance) * 0.1;

                slide.style.display = 'block'; // Убедиться, что слайд отображается
            }
        }
    });
}

// Функция для получения конфигураций в зависимости от направления и размера экрана
function getDirectionConfig(direction) {
    var width = window.innerWidth;
    if (width >= 768 && width < 1200) {
        // Планшетные размеры
        switch (direction) {
            case 'top':
                return {
                    radiusXClose: 10,
                    radiusYClose: 0,
                    depthZClose: 0,
                    radiusXFar: 10,
                    radiusYFar: -50,
                    depthZFar: 0,
                    rotationAngle: -11,
                    centerOriginNext: '0% 0%',
                    centerOriginPrev: '100% 0%',
                    originXNext: '0%',
                    originXPrev: '100%',
                    originY: '0%'
                };
            case 'default':
            default:
                return {
                    radiusXClose: 10,
                    radiusYClose: 0,
                    depthZClose: 0,
                    radiusXFar: 10,
                    radiusYFar: 50,
                    depthZFar: 0,
                    rotationAngle: 11,
                    centerOriginNext: '0% 100%',
                    centerOriginPrev: '100% 100%',
                    originXNext: '0%',
                    originXPrev: '100%',
                    originY: '100%'
                };
        }
    } else if (width >= 1200) {
        // Десктопные размеры
        switch (direction) {
            case 'top':
                return {
                    radiusXClose: 20, // Смещение по оси X для соседних слайдов
                    radiusYClose: 0, // Смещение по оси Y для соседних слайдов
                    depthZClose: 0, // Глубина по оси Z для соседних слайдов
                    radiusXFar: 20, // Смещение по оси X для дальних слайдов
                    radiusYFar: -120, // Смещение по оси Y для дальних слайдов (подъем вверх)
                    depthZFar: 0, // Глубина по оси Z для дальних слайдов
                    rotationAngle: -15, // Угол поворота в противоположную сторону
                    centerOriginNext: '0% 0%', // Точка вращения центрального слайда при движении вперед
                    centerOriginPrev: '100% 0%', // Точка вращения центрального слайда при движении назад
                    originXNext: '0%', // Точка вращения по оси X для правых слайдов
                    originXPrev: '100%', // Точка вращения по оси X для левых слайдов
                    originY: '0%' // Точка вращения по оси Y для всех слайдов
                };
            case 'default':
            default:
                return {
                    radiusXClose: 20,
                    radiusYClose: 0,
                    depthZClose: 0,
                    radiusXFar: 20,
                    radiusYFar: 120, // Смещение вниз для дальних слайдов
                    depthZFar: 0,
                    rotationAngle: 15,
                    centerOriginNext: '0% 100%', // Точка вращения центрального слайда при движении вперед
                    centerOriginPrev: '100% 100%', // Точка вращения центрального слайда при движении назад
                    originXNext: '0%',
                    originXPrev: '100%',
                    originY: '100%' // Нижний край слайда
                };
        }
    } else {
        // Мобильные размеры - пользовательское позиционирование слайдов не требуется
        return null;
    }
}

const screenBgArrow = document.querySelectorAll('.screen-bg__arrow');
screenBgArrow.forEach(element => {
    gsap.to(element,
        {
            y: 20,
            yoyo: true,
            duration: 1,
            repeat: -1
        })
});



// Меню

const hamburger = document.querySelector('.hamburger');
const nav = document.querySelector('.nav');
const body = document.querySelector('body');

hamburger.addEventListener('click', function () {
    if (hamburger.classList.contains('active')) {
        document.querySelectorAll('.nav__link').forEach(elem => { elem.classList.remove('active') });
    }
    hamburger.classList.toggle('active');
    nav.classList.toggle('active');
    body.classList.toggle('body-no-scroll');
});

// Модалка

document.addEventListener('DOMContentLoaded', function () {
    const modal = document.querySelector('.modal');
    const closeModalButton = document.querySelector('.modal__close');

    // Открытие модального окна
    function openModal() {
        modal.classList.add('active');
        document.body.classList.add('hidden'); // Блокировка прокрутки страницы
    }

    // Закрытие модального окна
    function closeModal() {
        modal.classList.remove('active');
        document.body.classList.remove('hidden'); // Возврат прокрутки страницы
    }

    // Закрытие по крестику
    closeModalButton.addEventListener('click', closeModal);

    // Закрытие по клику за пределами модального окна
    modal.addEventListener('click', function (event) {
        if (event.target === modal) {
            closeModal();
        }
    });

    // Пример кнопки для открытия модального окна (добавь кнопку в HTML для тестирования)
    document.querySelector('.team-modal-btn').addEventListener('click', openModal);
});
